export var buildCredentials = function buildCredentials(secOptions) {
  return secOptions && secOptions.omitCredentials ? 'omit' : 'include';
};